<template>
	<section class="calendar">
		<b-alert variant="danger" :show="isError">Une erreur inattendue est survenue. Si elle persiste, veuillez contacter Kemtag.</b-alert>
		<transition name="slide-fade">
			<div class="d-flex justify-content-center align-items-center loader" v-bind:class="{'loader_with_alert': isError}" v-if="isBusy">
				<b-spinner label="Chargement..." variant="primary"></b-spinner>
			</div>
		</transition>
		<vue-cal v-if="!mobile"
		class="vuecal--green-theme "
		v-bind:class="{'cal_heigth_with_alert': isError, 'cal_heigth' : !isError}"
		ref="vuecal"
		:events="rentals"
		:selected-date="selectedDate"
		:time-from="0 * 60"
		:time-to="24 * 60"
		:time-step="120"
		:timeCellHeight="window.height/16"
		locale="fr"
		:min-event-width="50"
		:clickToNavigate="true"
		:editable-events="{title: false, drag: false, resize: false, delete: false, create: false}"
		:active-view.sync="activeView"
		:disable-views="['years', 'year', 'day']"
		:cell-click-hold="false"
		events-on-month-view="short"
		:on-event-click="info"
		@ready="onReady"
		@view-change="onViewChange"
		@cell-click="onCreate"
		>
				<template v-slot:event="{ event, view }">

					<div class="vuecal__event-title">{{event.title}}</div>
					<div v-if="view == 'week'">
						<div class="vuecal__event-content" v-if="event.class!='external'">
							<div class="vuecal__event-content" v-if="event.class=='clotured'">
								Validé {{event.cumul_valid}}<span>&nbsp;{{event.unit_title_label}}</span><br>
								<div v-if="event.unit_title!=4">
									<div v-if="event.class=='reel'">
										<span>&nbsp;Saisi {{parseFloat((event.cumul_terrain_converted*10).toFixed(0))/10}}</span><span>&nbsp;{{event.unit_title_label}}</span>
									</div>
									<div v-else>
										<span>&nbsp;Mesuré {{parseFloat((event.cumul_terrain_converted*10).toFixed(0))/10}}</span><span>&nbsp;{{event.unit_title_label}}</span>
									</div>
								</div>
							</div>
							<div class="vuecal__event-content" v-else>
								<div v-if="event.unit_title!=4">
									<span>&nbsp;{{parseFloat((event.cumul_terrain_converted*10).toFixed(0))/10}}</span><span>&nbsp;{{event.unit_title_label}}</span>
								</div>
								<div v-if="event.class!='reel'">
									{{event.cumul_terrain}}<span>&nbsp;Unités</span><br>
								</div>
							</div>
						</div>
						<div class="vuecal__event-content" v-if="event.class=='external'">
							<span>&nbsp;{{ event.cumul_terrain}}</span><span>&nbsp;Unités</span>
							<!--
							<div v-if="event.unit_title!=4">
								<span>&nbsp;{{parseFloat((event.cumul_terrain_converted*10).toFixed(0))/10}}</span><span>&nbsp;{{event.unit_title_label}}</span>
							</div>
							<div v-else>
								<span>&nbsp;{{event.title}}</span>
							</div>-->
						</div>
					</div>

					<div class="vuecal__event-time" v-if="view == 'week'">
						<div v-if="event.isMultiDays">
							{{ event.start | moment("L HH:mm")  }} <span>&nbsp;- {{ event.end | moment("L HH:mm") }}</span>
						</div>
						<div v-else>
							{{ event.start | moment("HH:mm")  }} <span>&nbsp;- {{ event.end | moment("HH:mm") }}</span>
						</div>
					</div>
				</template>
			<template v-slot:no-event>&nbsp;</template>
		</vue-cal>

		<vue-cal v-if="mobile"
		hide-view-selector
		small
		xsmall
		:allDayBarHeight="window.height"
		class="vuecal--green-theme "
		v-bind:class="[ mobile_version ?{ 'cal_heigth_with_alert_mobile_version': isError, 'cal_heigth_mobile_version' : !isError }:{ 'cal_heigth_with_alert_mobile': isError, 'cal_heigth_mobile' : !isError }]"
		ref="vuecal"
		:events="rentals" 
		:selected-date="selectedDate" 
		:time-from="0 * 60" 
		:time-to="24 * 60" 
		:time-step="120"
		:timeCellHeight="window.height/16"
		locale="fr"
		:min-event-width="50" 
		:editable-events="{ title: false, drag: false, resize: false, delete: false, create: false }"
		:active-view.sync="activeView"
		:disable-views="['years', 'year', 'day']"
		:cell-click-hold="false"
		events-on-month-view="short"
		:on-event-click="info"
		@ready="onReady"
		@view-change="onViewChange"
		@cell-click="onCreate"
		>
			<template v-slot:event="{ event, view }">

				<div class="vuecal__event-title">{{ event.title }}</div>
				<div v-if="view == 'week'">
					<div class="vuecal__event-content" v-if="event.class!='external'">
						<div class="vuecal__event-content" v-if="event.class=='clotured'">
							{{event.cumul_valid}}<span>&nbsp;{{event.unit_title_label}}</span><br>
							<div v-if="event.unit_title!=4">
								<span>&nbsp;{{parseFloat((event.cumul_terrain_converted*10).toFixed(0))/10}}</span><span>&nbsp;{{event.unit_title_label}}</span>
							</div>
						</div>
						<div class="vuecal__event-content" v-else>
							<div v-if="event.unit_title!=4">
								<span>&nbsp;{{parseFloat((event.cumul_terrain_converted*10).toFixed(0))/10}}</span><span>&nbsp;{{event.unit_title_label}}</span>
							</div>
							<div v-if="event.class!='reel'">
								{{event.cumul_terrain}}<span>&nbsp;Unités</span><br>
							</div>
						</div>
					</div>
					<div class="vuecal__event-content" v-if="event.class=='external'">
						<span>&nbsp;{{ event.cumul_terrain}}</span><span><br>Unités</span>
						<!--
						<div v-if="event.unit_title!=4">
							<span>&nbsp;{{parseFloat((event.cumul_terrain_converted*10).toFixed(0))/10}}</span><span>&nbsp;{{event.unit_title_label}}</span>
						</div>
						<div v-else>
							<span>&nbsp;{{event.title}}</span>
						</div>-->
					</div>
				</div>

				<div class="vuecal__event-time" v-if="view == 'week'">
					<div v-if="event.isMultiDays">
						{{ event.start | moment("L HH:mm")  }} <span>&nbsp;- {{ event.end | moment("L HH:mm") }}</span>
					</div>
					<div v-else>
						{{ event.start | moment("HH:mm")  }} <span>&nbsp;- {{ event.end | moment("HH:mm") }}</span>
					</div>
				</div>
			</template>
			<template v-slot:no-event>&nbsp;</template>
		</vue-cal>
		<calendar-create ref="modalCreate" :rental_max_lenght="this.rental_max_lenght" @add-event="onEventAdd"/>
		<calendar-info ref="modalInfo" :system-id="this.systemId" :rental_max_lenght="this.rental_max_lenght" @edit-event="onEventEdit"/>
	</section>

</template>

<script>
	
	import VueCal from 'vue-cal';
	import 'vue-cal/dist/i18n/fr.js'
	import 'vue-cal/dist/vuecal.css';
	import 'vue-cal/dist/drag-and-drop.js'

	import { mapGetters } from 'vuex';

	import CalendarCreate from './CalendarCreate.vue';
	import CalendarInfo from './CalendarInfo.vue';

	export default {
		name: "Calendar",
		components: { VueCal, CalendarCreate, CalendarInfo},
		computed: {
			...mapGetters({
				rentals : 'rentals/getRentals'
			})
		},
		props: ['systemId','rental_max_lenght'],
		data: () => ({
			selectedDate: new Date(),
			activeView: "week",
			isBusy: true,
			isError: false,
			currentStartDate : null,
			currentEndDate : null,
			mobile: false,
			mobile_version : false,
			window: {
				width: 0,
				height: 0
			},
		}),
		watch: {
			'systemId': function (newVal, oldVal) {
				this.$store.dispatch('rentals/setSystemId', {'system_id' : newVal});
				this.load(this.systemId, this.currentStartDate, this.currentEndDate);
			}
		},
		created() {
			this.$store.dispatch('rentals/setSystemId', {'system_id' : this.systemId});
            window.addEventListener('resize', this.handleResize);
            this.mobile_version = window.location.hash.includes("m.calendar");
            this.handleResize();
		},
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
		methods: {
			onReady(e) {
				this.currentStartDate = e.startDate;
				this.currentEndDate = e.endDate;
				this.load(this.systemId, e.startDate, e.endDate);
			},
			onViewChange(e) {
				this.currentStartDate = e.startDate;
				this.currentEndDate = e.endDate;
				this.load(this.systemId, e.startDate, e.endDate);
			},
			onEventAdd(e) {
				this.selectedDate = e;
				this.activeView = "week";
			},
			onEventEdit(e) {
				this.selectedDate = new Date(e);
			},
			load(system_id, startDate, endDate) {
				this.isBusy = true;
				this.$store.dispatch('rentals/load', { 
					'system_id': system_id, 
					'startDate': startDate, 
					'endDate': endDate 
				}).then((res) => {

					this.isBusy = false;
					this.isError = false;
				}).catch((error) => {
					this.isError = true;
				})
			},
			onCreate(date) {
				if(this.activeView == "week") {
					this.$refs.modalCreate.show(date,this.rental_max_lenght);
				}
			},
			onCreateClick(rental_max_lenght) {
				if(this.activeView == "month") {
					this.activeView = "week"
				}
				this.rental_max_lenght = rental_max_lenght;
				this.$refs.modalCreate.show(new Date(),this.rental_max_lenght);
			},
			info(event, e) {
				//if(this.activeView == 'week') {
					this.$refs.modalInfo.show(event,this.rental_max_lenght);			
				//}

				// Prevent navigating to narrower view (default vue-cal behavior).
				e.stopPropagation();
			},
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
                this.mobile=(this.window.width<1080)? true : false ;
            },			
		}
	}

</script>

<style>

.calendar {
	position: relative;
}

.cal_heigth {
	height: calc(100vh - 180px);
}

.cal_heigth_mobile {
	height: calc(100vh - 125px);
}

.cal_heigth_mobile_version {
	height: calc(100vh);
}

.vuecal__time-cell{
	color:#999;
	text-align:right;
	padding-right:2px;
	font-size:.9em;
	height:51.33px;
}
.cal_heigth_with_alert {
	height: calc(100vh - 243px);
}

.cal_heigth_with_alert_mobile {
	height: calc(100vh - 188px);
}
.cal_heigth_with_alert_mobile_version {
	height: calc(100vh - 63px);
}


.loader_with_alert {
	top: 142px !important;
}

.loader {
	position: absolute;
	top: 79px;
	left: 0px;
	right: 0px;
	bottom: 0px;
	background: rgba(0,0,1,0.1);
	z-index: 200;
}

.slide-fade-enter-active {
	transition: all 0.1s ease;

}
.slide-fade-leave-active {
	transition: all 0.1s ease; 
}

.vuecal__cell-events {
	position: relative;
	width: 90%;
	height: 100%;
}

.vuecal__now-line {color: #06c;}

.modal-backdrop {
	background: rgba(0, 0, 0, 0.4);
}

.vuecal__event.default {
	background-color: #90cdf4;
	border: 1px solid #3182ce;
	color: #444;
}

.default {
	background-color: #90cdf4 !important;border: 1px solid #3182ce !important;color: #444 !important;
}

.vuecal__event.external {
	background-color: #fbd38d;border: 1px solid #dd6b20;color: #444;
}

.external {
	background-color: #fbd38d !important;border: 1px solid #dd6b20 !important;color: #444 !important;
}

.vuecal__event.reel {
	background-color: #ae90f4;border: 1px solid #5429b8;color: #444;
}

.reel {
	background-color: #ae90f4 !important;border: 1px solid #5429b8 !important;color: #444 !important;
}

.vuecal__event.valid {
	background-color: #9ae6b4;border: 1px solid #38a169;color: #444;
}

.valid {
	background-color: #9ae6b4 !important;border: 1px solid #38a169 !important;color: #444 !important;
}

.vuecal__event.clotured {
	background-color: #c6dbcd;border: 1px solid #91a098;color: #444;
}

.clotured {
	background-color: #c6dbcd !important;border: 1px solid #91a098 !important;color: #444 !important;
}

.vuecal__event.unknown_user {
	background-color: #e22b2b;border: 1px solid #ca59a5;color: #444;
}

.unknown_user {
	background-color: #e22b2b !important;border: 1px solid #ca59a5 !important;color: #444 !important;
}

.activity {
	min-height: 0px !important;
}
</style>